// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__v6cSs","slider":"Switch_slider__zmd1-","round":"Switch_round__Jr4lX"};